import axios from 'axios'
import { isBlank, parseString, formatNumber } from '../../commons.js'
import ApplicationController from '../application_controller.js'

/*
 *
 */

export default class InvoiceController extends ApplicationController {

  static targets = ["currencyRate", "currencyRateBlock", "submitButton", "entity", "billingContactId"]

  connect() {
    this.submitButtonTarget.addEventListener("mouseover", () => { document.activeElement.blur() }, false);
  }

  preview() {
    let form = this.element.querySelector('form')
    axios.post(form.dataset.previewPath, new FormData(form)).then(response => {
      this.element.querySelector('#invoice_header').innerHTML = response.data["header"]
      this.element.querySelector('#add_special_rows_container').innerHTML = response.data["rows"]
      this.element.querySelector('#rows_footer').innerHTML = response.data["rows_footer"]
    })
  }

  addSpecialRow(e) {
    let entity_id = this.entityTarget.options[this.entityTarget.selectedIndex].value
    axios.get(`${e.target.dataset.path}?value=${e.target.value}&entity_id=${entity_id}`).then(response => {
      this.element.querySelector('#add_special_rows_container').insertAdjacentHTML('afterbegin', response.data)
      e.target.remove(e.target.selectedIndex)
    })
  }

  addCfile(e) {
    let entity_id = this.entityTarget.options[this.entityTarget.selectedIndex].value
    let url = `${e.target.dataset.path}?value=${e.target.value}&entity_id=${entity_id}`
    axios.get(url).then(response => {
      this.element.querySelector('#add_cfile_rows_container').insertAdjacentHTML('afterbegin', response.data)
      e.target.remove(e.target.selectedIndex)
      this.preview()
    })
  }

  clickedSubmit(e) {
    let form = e.target.closest('form')

    form.submit()
    e.target.disabled = true
  }

  selectEntity(e) {
    this.element.querySelectorAll('.row_vat_rate').forEach(el => { // cf _rows.html.erb ligne 79
      el.value = formatNumber(parseFloat(e.target.options[e.target.selectedIndex].getAttribute('data-vat-rate')) * 100)
    })
    this.preview()
  }

  selectCurrency(e) {
    let selected_currency = e.target.options[e.target.selectedIndex]
    this.currencyRateTarget.value = selected_currency.getAttribute('data-rate')
    if (selected_currency.getAttribute('data-is-default') == "true") {
      this.currencyRateBlockTarget.style.visibility = "hidden"
    }
    else {
      this.currencyRateBlockTarget.style.visibility = "visible"
    }
  }

  selectBillingContact(e) {
    let contact_id = e.target.options[e.target.selectedIndex].dataset.contact_id
    contact_id = contact_id === undefined ? "" : contact_id
    this.billingContactIdTarget.value = contact_id
  }

}